import React, { useRef } from 'react';
import { useSelector } from 'react-redux';

import { StatsSection } from 'widgets/statspro/js/components/common/stats-section';
import { RoundListNavItem } from 'common/react/components/competition-nav/nav-items';
import { navSelector } from 'common/store/modules/competition-nav/selectors';
import { useCompetitionNavigationOptions } from 'common/react/hooks/use-competition-navigation-options';
import { useNavSync } from 'common/react/components/competition-nav/hooks/use-nav-sync';
import { useGetCurrentCompFilters } from 'common/react/components/competition-nav/hooks/use-get-current-comp-filters';
import { ExpandLineupsToggle } from './components/ExpandLineupsToggle';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import { useFiltersTracking } from 'common/react/hooks/use-filters-tracking';
import { SelectARoundText } from './components/SelectARoundText';

const TOGGLE_WRAP_MAX_WIDTH = 1125;

export const TeamLineupsNav = ({
    competitionId,
    seasonId,
    expandLineups,
    setExpandLineups,
    title,
    fixtureParam
}) => {
    const showResponsiveItems = useMediaQuery({
        maxWidth: PULSE.app.measurements.desktop
    });

    const wrapToggle = useMediaQuery({
        maxWidth: TOGGLE_WRAP_MAX_WIDTH
    });

    const initialValues = fixtureParam
        ? fixtureParam
        : {
              competitionId,
              seasonId
          };

    const nav = useSelector(navSelector);
    const options = useCompetitionNavigationOptions(nav);

    useNavSync({ ...options, initialValues });

    const currentFilters = useGetCurrentCompFilters();
    const competitionNavRef = useRef();

    useFiltersTracking({
        title: `${title} filters`,
        filtersState: {
            ...nav,
            expandLineups
        },
        options,
        filtersFields: [
            'competition',
            'season',
            'round',
            'teams',
            'venues',
            'cities',
            'expandLineups'
        ],
        filtersRef: competitionNavRef
    });

    return (
        <div
            className="competition-nav filter-dropdown"
            ref={competitionNavRef}
        >
            <StatsSection.Main>
                <StatsSection.Nav>
                    {!showResponsiveItems ? (
                        <StatsSection.NavItems>
                            <SelectARoundText classes="flex-grow" />
                            {currentFilters?.round?.providerId &&
                            !wrapToggle ? (
                                <ExpandLineupsToggle
                                    isActive={expandLineups}
                                    onChange={setExpandLineups}
                                    classes={
                                        'competition-nav__lineups-toggle-wrapper'
                                    }
                                />
                            ) : null}
                        </StatsSection.NavItems>
                    ) : null}

                    {wrapToggle ? (
                        <StatsSection.AdditionalNavItems className="gutter">
                            <ExpandLineupsToggle
                                isActive={expandLineups}
                                onChange={setExpandLineups}
                                classes={
                                    'competition-nav__lineups-toggle-wrapper'
                                }
                                reversed={true}
                            />
                        </StatsSection.AdditionalNavItems>
                    ) : null}

                    <StatsSection.RoundButtons>
                        <RoundListNavItem
                            classes={'competition-nav__round-filter-wrapper'}
                            title={title}
                        />
                    </StatsSection.RoundButtons>
                </StatsSection.Nav>
            </StatsSection.Main>
        </div>
    );
};

TeamLineupsNav.propTypes = {
    competitionId: PropTypes.string,
    seasonId: PropTypes.string,
    expandLineups: PropTypes.bool,
    setExpandLineups: PropTypes.func,
    title: PropTypes.string,
    fixtureParam: PropTypes.object
};
